import { createAction } from '@reduxjs/toolkit';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { showNotificationAsync } from '../notifications/actions';
import { RootState } from '../store';
import * as gooService from './service';
import { GeoSuggestsUI } from './types';

export const setGeoSuggestLoading = createAction<{
    isLoading: boolean;
}>('@@collections/SET_GEO_SUGGESTS_LOADING');

export const setGeoSuggests = createAction(
    '@@direct/SET_GEO_SUGGESTS',
    (payload: GeoSuggestsUI) => ({ payload }),
);

export function loadGeoSuggestsAsync(
    query?: string,
): ThunkAction<void, RootState, undefined, AnyAction> {
    return async (dispatch) => {
        dispatch(setGeoSuggestLoading({ isLoading: true }));

        try {
            const response = await gooService.loadGeoSuggest(query ?? '');

            dispatch(setGeoSuggests(response));
        } catch (error) {
            dispatch(showNotificationAsync('Не удалось загрузить регионы'));
        }

        dispatch(setGeoSuggestLoading({ isLoading: false }));
    };
}
